/* unplugin-vue-components disabled */import { render } from "./SingerV2.vue?vue&type=template&id=3ef28e00"
import script from "./SingerV2.vue?vue&type=script&lang=js"
export * from "./SingerV2.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__